import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, CircularProgress, Paper } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import AlertDialog from 'src/app/common/components/AlertDialog';
import AppPaperTitle from 'src/app/common/components/AppPaperTitle';
import { useTranslation } from 'src/app/common/hook/translation.hook';
import { bdmSentBackFromCodeMap, policyTaskStatusMap } from '../../../constants/common.constant';
import { fetchBdmSubmittedBatchFile } from '../../../network/opm-pd-bdm';
import { BatchFilesViewPageContext, BatchFilesViewPageContextType } from './BatchFilesView.context';
import AdditionalInformation from './components/AdditionalInformation/AdditionalInformation';
import PolicyTable from './components/PolicyTable/PolicyTable';

const BatchFilesViewPage = () => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { bdmBatchFileId } = useParams<{ bdmBatchFileId: string }>();

  const [bdmSubmittedBatchFile, setBdmSubmittedBatchFile] =
    useState<BatchFilesViewPageContextType['bdmSubmittedBatchFile']>(null);
  const [bdmSubmittedBatchFileLoading, setBdmSubmittedBatchFileLoading] = useState(true);

  const policies = useMemo<BatchFilesViewPageContextType['policies']>(
    () =>
      bdmSubmittedBatchFile?.policies?.map((policy) => {
        const selectedQualifiedAgent = policy.isSelectedOtherAgent ? policy.selectedAgent : '';
        const selectedQualifiedAgentName = policy.isSelectedOtherAgent ? policy.selectedAgentName : '';

        // const sentBackFromLabel = bdmSentBackFromCodeMap[policy.sentBackFrom]?.label || policy.sentBackFrom || '';
        const policyTaskStatusLabel =
          policyTaskStatusMap[policy.policyTaskStatus]?.label || policy.policyTaskStatus || '';
        // const policyTaskStatusLabel = policy.policyTaskStatus || '';
        return {
          ...policy,
          _selectedQualifiedAgentName: selectedQualifiedAgentName || '',
          _selectedQualifiedAgent: selectedQualifiedAgent || '',
          _sentBackFromLabel: policy.actionedReason,
          _policyTaskStatusLabel: policyTaskStatusLabel ? policyTaskStatusLabel : '',
        };
      }) ?? [],
    [bdmSubmittedBatchFile, t],
  );

  const fetchBdmSubmittedBatchFileData = async () => {
    setBdmSubmittedBatchFileLoading(true);
    try {
      const data = await fetchBdmSubmittedBatchFile(bdmBatchFileId, dispatch);
      setBdmSubmittedBatchFile(data);
    } catch (error) {
      history.push('/opm-pd/policy-transfer-request/batch-files');
    } finally {
      setBdmSubmittedBatchFileLoading(false);
    }
  };

  useEffect(() => {
    fetchBdmSubmittedBatchFileData();
  }, [bdmBatchFileId]);

  return (
    <BatchFilesViewPageContext.Provider
      value={{
        bdmSubmittedBatchFile,
        bdmSubmittedBatchFileLoading,
        policies,
      }}
    >
      <AlertDialog />
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" justifyContent="flex-start" gap={2}>
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            color="error"
            component={Link}
            to="/opm-pd/policy-transfer-request/batch-files"
          >
            Back
          </Button>
        </Box>
        {bdmSubmittedBatchFileLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Paper elevation={0} variant="elevation">
              <AppPaperTitle>{bdmSubmittedBatchFile?.batchNo}</AppPaperTitle>
            </Paper>
            <PolicyTable />
            <AdditionalInformation />
          </>
        )}
      </Box>
    </BatchFilesViewPageContext.Provider>
  );
};

export default BatchFilesViewPage;
